import 'babel-polyfill'
import Vue, { provide } from 'vue'
import App from '@components/App.vue'
import Vue2TouchEvents from 'vue2-touch-events'
import Vuex from 'vuex'
import * as orders from '@store/Store'
import { sync } from 'vuex-router-sync'
import router from '@/router/Routes'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import VueGeolocation from 'vue-browser-geolocation'
import { formatDate, formatDateTime, formatTime, formatTripDateTime } from '@util/dates-and-times'
import ClickOutsideDirective from '@util/clickOutsideDirective'
import {formatOdometer, formatTripOdometer} from '@util/odometerService'
import { ceilNumber, floorNumber, formatLocale, roundNumber } from '@util/numberFormat'
import setupRequestIdInterceptor from '@/interceptor/RequestIdInterceptor'
import setupResponseInterceptor from '@/interceptor/ResponseInterceptor'
import axios from 'axios'
import './registerServiceWorker'
import goBackDirective from '@util/goBackDirective'
import 'reflect-metadata'

Vue.config.productionTip = false
Vue.use(Vuex)

// only used so we get the typescript typing for vuerouter, won't be bundled for build
const forTypescriptTyping = VueRouter // eslint-disable-line no-unused-vars

Vue.use(Vuelidate)

Vue.use(VueGeolocation)

Vue.use(Vue2TouchEvents)

Vue.filter('formatTripDateTime', formatTripDateTime)

Vue.filter('formatTripOdometer', formatTripOdometer)

Vue.filter('formatOdometer', formatOdometer)

Vue.filter('roundNumber', roundNumber)

Vue.filter('floorNumber', floorNumber)

Vue.filter('ceilNumber', ceilNumber)

Vue.filter('formatNullable', (value) => {
  if (value) {
    return value
  }
  return '---'
})

Vue.filter('formatLocale', formatLocale)

Vue.filter('formatTime', formatTime)

Vue.filter('formatDate', formatDate)

Vue.filter('formatDateTime', formatDateTime)

Vue.directive('click-outside', ClickOutsideDirective)

Vue.directive('goBack', goBackDirective)

setupRequestIdInterceptor(axios)
setupResponseInterceptor(axios)

const store = orders.createStore()

sync(store, router, { moduleName: 'Router' })

window.onload = function () {
  const vueAppSelector = '#app'
  const vueAppContainer = document.querySelector(vueAppSelector) as HTMLElement | null

  if (vueAppContainer) {
    const modelData = Object.keys(vueAppContainer.dataset).reduce((model, modelKey) => {
      model[modelKey] = vueAppContainer.dataset[modelKey]
      return model
    }, {} as { [key: string]: string }) // eslint-disable-line no-undef

    new Vue({
      setup () {
        provide('vuex-3-store', store)
      },
      render: h => h(App, {
        props: {
          ...modelData,
        },
      }),
      store,
      router,
    }).$mount(vueAppSelector)
  }
}
